import React, { useRef, useEffect } from 'react';
import styles from './CommentInput.module.css';

const CommentInput = ({
    label,
    clue,
    title,
    value = '',
    onChange = () => { },
    error = '',
    display = 'textarea'
}) => {
    const textareaRef = useRef(null);

    // Автоматическое изменение высоты textarea
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 16}px`;
        }
    }, [value]);

    return (
        <div className={`${styles.container} ${error ? styles.error : ''}`}>
            <label className={styles.label}>{label}</label>
            <div className={styles.inputContainer}>
                {display == 'textarea' ? (
                    <>
                        
                        <div className={styles.title}>{title}</div>
                        <textarea
                            ref={textareaRef}
                            className={styles.textarea}
                            value={value}
                            onChange={onChange}
                            rows={1}
                        />
                        <div className={styles.clue}>{clue}</div>
                    </>
                ) : display == 'input' ? (
                    <>
                        <div className={styles.title}>{title}</div>
                        <input
                            type='text'
                            onChange={onChange}
                            className={styles.input}
                            value={value}
                        />
                        <div className={styles.clue} style={{ width: "100%"}}>{clue}</div>
                    </>
                ) : (
                    <>
                        <div className={styles.title}>{title}</div>
                        <textarea
                            ref={textareaRef}
                            className={styles.textarea}
                            value={value}
                            onChange={onChange}
                            rows={1}
                        />
                    </>
                )}

                {error && <div className={styles.errorMessage}>{error}</div>}
            </div>
        </div>
    );
};

export default CommentInput;